import { FC } from "react";
import { Grid2 as Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import PatientProfileTile from "@components/Home/PatientProfileTile/PatientProfileTile";
import CompanionTile from "@components/Home/CompanionTile";
import RecentConversationsTile from "@components/Home/RecentConversationsTile";
import UpcomingScheduleTile from "@components/Home/UpcomingScheduleTile";
import AlbumsTile from "@components/Home/AlbumsTile";
import CaregiverGamesPanel from "@components/Home/Games/CaregiverGamesPanel";
import DashboardWrapper from "@components/Home/DashboardWrapper";
import { useDriver } from "@hooks/useDriver";

const Dashboard: FC = () => {
  useDriver();
  const selectedPatientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );

  return (
    <DashboardWrapper>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PatientProfileTile />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
          <CompanionTile />
        </Grid>
        {selectedPatientId && (
          <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            <CaregiverGamesPanel patientId={selectedPatientId} />
          </Grid>
        )}
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <RecentConversationsTile />
        </Grid>
        <Grid size={12}>
          <AlbumsTile />
        </Grid>
        <Grid size={12}>
          <UpcomingScheduleTile />
        </Grid>
      </Grid>
    </DashboardWrapper>
  );
};

export default Dashboard;
